<template>
  <article class="bookmark-item">
    <component
      :is="comp"
      :bookmark="bookmark" :user-id="userId" :membership="membership" :public-mode="publicMode"
      @toggle-select="onToggleSelect"
      @tag-selected="onSelectTag"
      @favorite="onAction('favorite', $event)"
      @save="onAction('save', $event)"
      @comments="onAction('comments', $event)"
      @add-to-collection="onAction('add-to-collection', $event)"
      @add-to-collection-from-collection="onAction('add-to-collection-from-collection', $event)"
      @like="onAction('like', $event)"
      @likes="onAction('likes', $event)"
      @pin-edit="onAction('pin-edit', $event)"
    />
  </article>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { ITEM_LAYOUT_STYLE } from '@/utils/constants'
import BookmarkCard from './BookmarkCard.vue'
import BookmarkListItem from './BookmarkListItem.vue'
import BookmarkHeadline from './BookmarkHeadline.vue'
import BookmarkTile from './BookmarkTile.vue'

const props = defineProps({
  // Accepts both Bookmark and CollectionItem (when resourceType is 'bookmark')
  bookmark: {
    type: Object,
    required: true,
  },
  userId: {
    type: String,
    default: null,
  },
  membership: {
    type: Object,
    default: null,
  },
  listStyle: {
    type: String,
    default: 'card',
  },
  publicMode: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['action', 'filter-tags'])

const STYLES = {
  [ITEM_LAYOUT_STYLE.cards]: BookmarkCard,
  [ITEM_LAYOUT_STYLE.list]: BookmarkListItem,
  [ITEM_LAYOUT_STYLE.headlines]: BookmarkHeadline,
  [ITEM_LAYOUT_STYLE.tiles]: BookmarkTile,
}

const comp = computed(() => STYLES[props.listStyle])

function onSelectTag(tag) {
  emit('filter-tags', tag.id)
}

function onAction(action, event) {
  emit('action', { action, event })
}

function onToggleSelect(event) {
  emit('action', { action: 'toggle-select', event })
}
</script>
